import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

import { useCashbackContext } from "../../context/cashback.context";

export const Price = () => {
    const { t } = useGranite();
    const { priceAfterCashbackIsApplied } = useCashbackContext();
    return (
        <>
            {t(
                "ecommerce.label.priceAfterCashback",
                formatPrice(priceAfterCashbackIsApplied ?? undefined)
            )}
        </>
    );
};
